import { ListSubheader, ListSubheaderProps, styled, Typography, TypographyProps } from '@mui/material';

export const TicketHistoryTitleText = styled((props: TypographyProps) => (
    <Typography {...props} variant="subtitle1" variantMapping={{ subtitle1: 'h6' }} />
))(
    ({ color }) => `
    color: ${color as string | '#353A67'};
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
`,
);

export const TicketHistoryTitle = styled(
    ({ textColor, ...props }: ListSubheaderProps & { textColor?: TypographyProps['color'] }) => (
        <ListSubheader {...props}>
            <TicketHistoryTitleText color={textColor}>{props.children}</TicketHistoryTitleText>
        </ListSubheader>
    ),
)(
    ({ theme }) => `
    padding-left: ${theme.spacing(5)};
    margin-bottom: ${theme.spacing(4)};
    background: transparent;
`,
);
